import { getHandler } from 'src/utils/fetchHandler';

export const GET_OPPORTUNITY_STATUSES = 'GET_OPPORTUNITY_STATUSES/OPPORTUNITY_STATUSES/@WISELY/WEB';
export const FETCH_OPPORTUNITY_STATUSES_SUCCEEDED =
	'FETCH_OPPORTUNITY_STATUSES_SUCCEEDED/OPPORTUNITY_STATUSES/@WISELY/WEB';
export const FETCH_OPPORTUNITY_STATUSES_FAILED =
	'FETCH_OPPORTUNITY_STATUSES_FAILED/OPPORTUNITY_STATUSES/@WISELY/WEB';

export const getOpportunityStatuses = () => ({
	type: GET_OPPORTUNITY_STATUSES,
});

export const fetchOpportunityStatusesSucceeded = payload => ({
	type: FETCH_OPPORTUNITY_STATUSES_SUCCEEDED,
	payload,
});

export const fetchOpportunityStatusesFailed = payload => ({
	type: FETCH_OPPORTUNITY_STATUSES_FAILED,
	payload,
});

export const fetchOpportunityStatuses = () => {
	return dispatch => {
		dispatch(getOpportunityStatuses());
		const path = `v2/opportunity_statuses`;

		return getHandler(path)
			.then(json => dispatch(fetchOpportunityStatusesSucceeded(json)))
			.catch(error => {
				console.error('fetchOpportunityStatuses error', error);
				dispatch(fetchOpportunityStatusesFailed(error));
			});
	};
};



// WEBPACK FOOTER //
// ./src/redux/opportunityStatuses/opportunityStatus.action.js